
<div id="player_container_modal" class="jwplayerwh">
    <div *ngIf="error_string">{{error_string}}</div>
</div>